import React from 'react';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useAFFilterContext } from 'hooks/AFFilterStoreContext';
import { useApi } from 'hooks/ApiStoreContext';
import { FormFilterAutoriteFourriere } from 'pages/autorite-fourriere/Dashboard/DashboardHeader/Filters/types';

import { FormFooter } from './FormFooter';

import './FormFooter/FormFooter.less';

interface FilterFormProps {
  filter: Partial<FormFilterAutoriteFourriere>;
  setFilter: (value: Partial<FormFilterAutoriteFourriere>) => void;
}

function FilterFormAutoriteFourriere({
  setFilter,
  filter,
}: FilterFormProps): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const initialsFilter = { ...filter };
  const [, , actionsRequises] = useAFFilterContext();

  const subForms = FiltersSubForms(refController, actionsRequises);

  return (
    <BaseForm
      initialValues={initialsFilter}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.classement,
            subForms.fourriere,
            subForms.commune,
            subForms.actionsRequises,
            subForms.statutsTraitementFacturation,
            subForms.includeDossiersAnonymises,
            subForms.includeOnlyNotDetruitApresSorti,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
          ],
        },
        {
          title: 'Suivi de mise en fourrière',
          inputs: [
            subForms.dateRangeOrdreDestruction,
            subForms.dateRangeBonEnlevement,
            subForms.dateRangeSortieDefinitive,
            subForms.motifDeSortie,
          ],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
    />
  );
}

export default FilterFormAutoriteFourriere;
